import { MEASURE_FAMILY } from '~/client/src/shared/map/labelLayerStyle'
import { STACK_CHIP_SPEC } from '~/client/src/shared/map/markerGeometry'

import Colors from '~/client/src/shared/theme.module.scss'

// Followed by the count, which no hex colour or fixed token can be mistaken for.
export const STACK_SEGMENT = 's'
export const STACK_SEGMENT_PATTERN = /^s(\d+)$/

// Past the chip's largest count every stack reads "9+", so they share one image.
const chipCount = (stackCount: number): number =>
  Math.min(stackCount, STACK_CHIP_SPEC.maxCount + 1)

// The layer appends the stack segment to a feature's own image ids, so the count never has to be
// known where those ids are built. stackedMarkerImageId spells the same id for warming it up.
export const stackedMarkerImage = (image: unknown): unknown => [
  'case',
  ['has', 'stackCount'],
  [
    'concat',
    image,
    `-${STACK_SEGMENT}`,
    ['to-string', ['min', ['get', 'stackCount'], chipCount(Infinity)]],
  ],
  image,
]

export const stackedMarkerImageId = (
  imageId: string,
  stackCount: number,
): string => `${imageId}-${STACK_SEGMENT}${chipCount(stackCount)}`

export function drawStackChip(
  ctx: CanvasRenderingContext2D,
  count: number,
  centerX: number,
  centerY: number,
  ratio: number,
): void {
  const { size, borderWidth, textSizePx, maxCount } = STACK_CHIP_SPEC
  ctx.beginPath()
  ctx.arc(centerX, centerY, ((size - borderWidth) / 2) * ratio, 0, Math.PI * 2)
  ctx.fillStyle = Colors.mapStackChipFill
  ctx.fill()
  ctx.lineWidth = borderWidth * ratio
  ctx.strokeStyle = Colors.mapWhite
  ctx.stroke()

  const label = count > maxCount ? `${maxCount}+` : String(count)
  ctx.font = `600 ${textSizePx * ratio}px ${MEASURE_FAMILY}`
  ctx.fillStyle = Colors.mapWhite
  ctx.textAlign = 'center'
  ctx.textBaseline = 'alphabetic'
  // Centred on the ink, not the line box: a digit has no descender to balance its ascent.
  const { actualBoundingBoxAscent, actualBoundingBoxDescent } =
    ctx.measureText(label)
  ctx.fillText(
    label,
    centerX,
    centerY + (actualBoundingBoxAscent - actualBoundingBoxDescent) / 2,
  )
}
